__turbopack_context__.v({
  "container": "no-results-module-scss-module__yeDL_a__container",
  "heading": "no-results-module-scss-module__yeDL_a__heading",
});
